import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'checkout',
        component: () => import('../views/Checkout.vue'),
        meta: { title: 'HooPay - Realize o Pagamento' },
    },

    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/ErrorView.vue'),
        meta: { title: 'HooPay - Produto não encontrado' },
    },
    {
        path: '/upsell',
        name: 'upsell',
        component: () => import('@/views/UpsellView.vue'),
        meta: { title: 'HooPay - Upsell' },
    },
    {
        path: '/billet/:uuid',
        name: 'billet',
        component: () => import('@/views/Billet.vue'),
        meta: { title: 'HooPay - Boleto' },
    },
    {
        path: '/payment/:uuid',
        name: 'payment-redirect',
        component: () => import('@/views/PaymentRedirectView.vue'),
        meta: { title: 'HooPay - Pedido' },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const title = to.meta.title as string;

    if (title) {
        document.title = title;
    }

    next();
});

export default router;
